import React from "react";
import { ShimmerDiv } from "./ThemedShimmer";

/**
 * Notifications, messages, sessions, search results, etc.
 */
const ListRowSkeleton = ({
  count = 5,
  rowHeight = 56,
  showAvatar = false,
  className = "",
}) => (
  <div
    className={`skeleton-list ${className}`.trim()}
    role="status"
    aria-busy="true"
    aria-label="Loading list"
  >
    <span className="skeleton-screen-reader-only">Loading list</span>
    {Array.from({ length: count }, (_, index) => (
      <div className="d-flex align-items-center gap-2" key={`list-skeleton-${index}`}>
        {showAvatar && <ShimmerDiv height={40} width={40} rounded={50} />}
        <ShimmerDiv
          className="mb-1 flex-grow-1"
          height={rowHeight}
          width="100%"
          rounded={8}
        />
      </div>
    ))}
  </div>
);

export default ListRowSkeleton;
